// extracted by css-extract-rspack-plugin
export default {"cls1":"useTabs-cls1_4lI","cls2":"useTabs-cls2_rts useTabs-cls1_4lI","active":"useTabs-active_JnY"};